import { render, staticRenderFns } from "./CAOG1040.vue?vue&type=template&id=0981505e&scoped=true"
import script from "./CAOG1040Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAOG1040Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAOG1040.vue?vue&type=style&index=0&id=0981505e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0981505e",
  null
  
)

export default component.exports